import useTranslation from '@/hooks/useTranslation'

const CANCELLED_CONFIG = {
    bg: 'bg-[#95A5A6]/10',
    text: 'text-[#95A5A6]',
    key: 'orders.statusCancelled',
}

const ERROR_CONFIG = {
    bg: 'bg-[#E74C3C]/10',
    text: 'text-[#E74C3C]',
}

const PENDING_CONFIG = {
    bg: 'bg-[#F39C12]/10',
    text: 'text-[#F39C12]',
}

const SUCCESS_CONFIG = {
    bg: 'bg-[#2ECC71]/10',
    text: 'text-[#2ECC71]',
}

const CONFIG = {
    fulfillment: {
        cancelled: CANCELLED_CONFIG,
        pending: { ...PENDING_CONFIG, key: 'orders.fulfillmentPending' },
        partially_fulfilled: { ...PENDING_CONFIG, key: 'orders.fulfillmentPartial' },
        fulfilled: { ...SUCCESS_CONFIG, key: 'orders.fulfillmentShipped' },
    },
    payment: {
        cancelled: CANCELLED_CONFIG,
        paid: { ...SUCCESS_CONFIG, key: 'orders.paymentPaid' },
        pending: { ...PENDING_CONFIG, key: 'orders.paymentDue' },
        overdue: { ...ERROR_CONFIG, key: 'orders.paymentOverdue' },
    },
    shipment: {
        created: { ...CANCELLED_CONFIG, key: 'orders.shipmentCreated' },
        unknown: { ...CANCELLED_CONFIG, key: 'orders.shipmentUnknown' },
        pre_transit: { ...PENDING_CONFIG, key: 'orders.shipmentPreTransit' },
        in_transit: { ...PENDING_CONFIG, key: 'orders.shipmentInTransit' },
        out_for_delivery: { ...PENDING_CONFIG, key: 'orders.shipmentOutForDelivery' },
        delivered: { ...SUCCESS_CONFIG, key: 'orders.shipmentDelivered' },
        available_for_pickup: { ...SUCCESS_CONFIG, key: 'orders.shipmentAvailableForPickup' },
        return_to_sender: { ...ERROR_CONFIG, key: 'orders.shipmentReturnToSender' },
        failure: { ...ERROR_CONFIG, key: 'orders.shipmentFailure' },
        cancelled: CANCELLED_CONFIG,
        error: { ...ERROR_CONFIG, key: 'orders.shipmentError' },
    },
}

export default function OrderStatusBadge({ type, status }) {
    const { t } = useTranslation()
    const config = CONFIG[type]?.[status]
    if (!config) return <span className="text-[12px]">—</span>
    return (
        <span
            className={`inline-flex items-center px-[8px] py-[4px] rounded-[4px] text-[12px] font-semibold ${config.bg} ${config.text}`}
        >
            {t(config.key)}
        </span>
    )
}
